import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "800",
  height: "800",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M9.27 14.669a.66.66 0 0 1-.88-.269l-.043-.095-1.818-3.998a.5.5 0 0 1 0-.145.327.327 0 0 1 .335-.328.3.3 0 0 1 .196.066l2.18 1.527a1 1 0 0 0 .546.167.9.9 0 0 0 .342-.066l10.047-4.5a10.73 10.73 0 0 0-8.171-3.526C6.478 3.502 2 7.232 2 11.87a7.83 7.83 0 0 0 3.46 6.296.66.66 0 0 1 .24.727l-.45 1.701a1 1 0 0 0-.051.24.327.327 0 0 0 .334.334.4.4 0 0 0 .19-.058l2.18-1.265c.16-.098.343-.151.531-.152q.15 0 .29.043c1.063.3 2.161.452 3.265.45 5.525 0 10.01-3.729 10.01-8.33a7.23 7.23 0 0 0-1.097-3.883L9.35 14.625z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }